import React from 'react';

/** Material Symbols Rounded glyph. Requires tokens/icons.css (loaded via styles.css). */
export function Icon({ name, size, fill = false, color, className = '', style, ...rest }) {
  return (
    <span
      className={`bjl-icon ${fill ? 'bjl-icon--fill' : ''} ${className}`}
      style={{ fontSize: size, color, ...style }}
      aria-hidden="true"
      {...rest}
    >
      {name}
    </span>
  );
}
